module.exports = __webpack_public_path__ + "img/imagen2.ff4cbb06.png";